<template>
    <div id="pdpa-page" class="bg-bzb-pdpa">
        <TopBar :label="lbl.topbar.label.signup" />
        <div class="pdpa-content mx-auto text-22 text-a-black-333333">
            <div class="pdpa-title">{{getTitle()}}</div>
                <PdpaContent
                    v-if="isRefresh"
                    :type="type"
                    :localeCode="localeCode"
                    @onError="onError($event)"
                    @onScroll="onScroll($event)"
                    @update:version="updateVersion($event)"
                    @updateMKTChannel="updateMKTChannel($event)" />
            </div>
        <div class="btn-footer-sec">
            <OrangeButton :isBtnDisable="btnDisable"
                id="submit-pdpa"
                @onClick="onAccept()">
                <div class="font-main">{{lbl.pdpa.btn_accept}}</div>
            </OrangeButton>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import Vue from "vue";
// helper
import Account from "@/helper/AccountHelper.js";
import CacheHelper from '@/helper/CacheHelper';
// mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
// component
import PdpaContent from '../component/PdpaContent.vue';
import OrangeButton from '@/components/Button/OrangeButton.vue';
import ModalMaster from '@/components/Modal/ModalMaster.vue';
//component
import TopBar from '@/components/Layout/TopBar/TopbarSignUp.vue';

export default {
    name: 'Pdpa',
    mixins: [LocaleMixin, ModalMixin],
    props: {
        typeProp: String
    },
    components: {
        PdpaContent,
        OrangeButton,
        ModalMaster,
        TopBar,
    },
    data: function () {
        return {
            type: 'terms',
            sessionCache: new CacheHelper('session'),
            cacheData: {
                terms: false,
                privacy: false,
                mkt: false,
                mkt_channel: { email: false, sms: false },
            },
            btnDisable: true,
            isRefresh: true,
            pdpaVersion: null,

            blobConfig: Account.getCacheBlob(),
            query: Account.getCacheQuery(),
            busTopbar: new Vue(),
        };
    },
    created: function () {
        this.type = this.$route.name;
        this.checkCache();
    },
    mounted: function() {

    },
    methods: {
        checkCache: function(){
            if(this.sessionCache.getCache('pdpa') == null){
                this.sessionCache.setCache('pdpa', this.cacheData);
            }
            return true;
        },
        getTitle: function(){
            let lbl = '';
            switch(this.type){
                case 'terms':
                    lbl = this.lbl.pdpa.terms_title;
                    break;
                case 'privacy':
                    lbl = this.lbl.pdpa.privacy_title;
                    break;
                case 'marketing':
                    lbl = this.lbl.pdpa.mkt_title;
                    break;
            }
            return lbl;
        },
        onError: function (error) {
            this.errorApi(error);
        },
        onScroll: function (bottomOfContent){
            this.btnDisable = !bottomOfContent;
        },
        clickBack: function(){
            this.$router.back();
        },
        onAccept: function(){
            if(this.type == 'terms'){
                this.type = 'privacy'
                this.refresh();
                this.updateCache('terms', this.pdpaVersion.termsVersion);
                this.$router.replace('/privacy');
            } else if (this.type == 'privacy'){
                this.type = 'marketing'
                this.refresh();
                this.updateCache('privacy', this.pdpaVersion.privacyVersion);
                this.$router.replace('/marketing');
            }
            else {
                this.cacheData = this.sessionCache.getCache('pdpa');
                if(!this.cacheData.mkt_channel.email && !this.cacheData.mkt_channel.sms){
                    this.confirmModal
                        .setTitle(this.lbl.pdpa.mkt_confirm_title)
                        .setMsg(this.lbl.pdpa.mkt_confirm_msg)
                        .setBtnCancel(this.lbl.pdpa.btn_skip)
                        .setBtnOk(this.lbl.pdpa.btn_back)
                        .show();

                    this.confirmModal.onClickCancel(()=>{
                        this.$router.replace('/register');
                    })
                }else{
                    this.$router.replace('/register');
                }
            }
        },
        refresh: function(){
            this.isRefresh = false;
            this.$nextTick(() => {
                this.isRefresh = true;
            });
        },
        updateCache: function(type, updateVal){
            if(!updateVal){
                this.cacheData[type] = 0;
            }
            this.cacheData[type] = updateVal;
            this.sessionCache.setCache('pdpa', this.cacheData);
        },
        updateMKTChannel: function(info){
            this.isDisabled = true;
            if(this.checkCache()){
                this.updateCache('mkt', this.pdpaVersion.marketingVertion);
                this.cacheData = this.sessionCache.getCache('pdpa');
                switch(info.type){
                    case 'email':
                        this.cacheData.mkt_channel.email = info.isChecked;
                        break;
                    case 'sms':
                        this.cacheData.mkt_channel.sms = info.isChecked;
                        break;
                }
                this.sessionCache.setCache('pdpa', this.cacheData);
            }
        },
        updateVersion: function(data){
            this.pdpaVersion = data;
        },
    }
}
</script>
<style lang="scss">
    @import "@/style/base/base.scss";
    @import "@/style/base/baseDisplay.scss";
    @import "@/style/base/baseUtility.scss";
    @import "./Pdpa.scss";
</style>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
#pdpa-page{
    .btn-orange{
        &.disabled{
            color: $a-gray-999999;
        }
    }
}

</style>
